import { useMemo } from 'react'

import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingRadioCardGroup } from '../../L3OnboardingRadioCardGroup'

import type {
  L3OnboardingRadioCardGroupProps,
  RadioCardItem,
} from '../../L3OnboardingRadioCardGroup'
import type { TrueFalseOptionType } from '../YesNo/YesNo'

export type BusinessAddressRemoteProps = Omit<
  L3OnboardingRadioCardGroupProps<TrueFalseOptionType>,
  'options'
>

/**
 * Circle L3 Onboarding BusinessAddressRemote Radio Card Group.
 */
export const BusinessAddressRemote: React.FC<BusinessAddressRemoteProps> = (
  props,
) => {
  const { t } = useTranslation('l3Onboarding')
  const options: RadioCardItem<TrueFalseOptionType>[] = useMemo(
    () => [
      {
        label: t`forms.physicalBusinessAddress.businessAddressRemote.options.false.label`,
        value: 'false',
      },
      {
        label: t`forms.physicalBusinessAddress.businessAddressRemote.options.true.label`,
        value: 'true',
      },
    ],
    [t],
  )

  return <L3OnboardingRadioCardGroup {...props} options={options} />
}
